export const pageInfo = {
  contribute: {
    event: {
      name: "Contribute Load",
    },
  },
  home: {
    event: {
      name: "Home Load",
    },
  },
  faq: {
    event: {
      name: "Frequently Asked Questions Load",
    },
  },
  packageProfile: {
    event: {
      name: "Package Profile Load",
    },
  },
  search: {
    event: {
      name: "Search Load",
    },
  },
  siteTerms: {
    event: {
      name: "Site Terms Load",
    },
  },
  notFound: {
    page: {
      pageType: "errorPage",
    },
    event: {
      name: "404 Page Load",
    },
  },
} as const;
